import React from 'react';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';
import styles from './phase-one.module.scss';

const Image = () => {
  const data = useStaticQuery(graphql`
    {
      file: contentfulTwilloPhase1 {
        image {
          fluid(maxWidth: 600) {
            ...GatsbyContentfulFluid_tracedSVG
          }
        }
      }
    }
  `);
  return <Img className={styles.image} fluid={data.file.image.fluid} />;
};

export default Image;
